import { mapSimpleArticle } from 'connectors/articleInterface/article/Article';
import { mapSimpleBlogArticle } from 'connectors/articleInterface/blogArticle/BlogArticle';
import { SimpleArticleInterfaceFragmentApi } from 'graphql/generated';
import { SimpleArticleInterfaceType } from 'types/articleInterface';

const mapSimpleArticleInterface = (
    apiData: SimpleArticleInterfaceFragmentApi,
): SimpleArticleInterfaceType | undefined => {
    switch (apiData.__typename) {
        case 'ArticleSite':
            return mapSimpleArticle(apiData);
        case 'BlogArticle':
            return mapSimpleBlogArticle(apiData);
        default:
            return undefined;
    }
};

export const mapSimpleArticlesInterface = (
    apiData: SimpleArticleInterfaceFragmentApi[],
): SimpleArticleInterfaceType[] => {
    const mappedArticles = [];

    for (const article of apiData) {
        const mappedArticle = mapSimpleArticleInterface(article);
        if (mappedArticle !== undefined) {
            mappedArticles.push(mappedArticle);
        }
    }

    return mappedArticles;
};
